import { Fragment, useEffect, useState } from "react";

import classes from './PreRegTwoContact.module.scss';

declare function Translate(key: string): string;
declare var _curLang: any;
declare var _siteSettings: any;
declare var _loginMethodSmsOtpUrl: any;

const PreRegTwoContact = (props) => {
    
    useEffect(() => {
        document.getElementById('popupContainer')?.focus();
    },[]);

    const redirectToForgottenPassword = () => {  
        window.location.href = `${_siteSettings.forgottenPasswordLink}&locale=${_curLang}`;
    };
  
    const forgotPapssPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            redirectToForgottenPassword();
        }        
    };

    const redirectToHome = () => {
        window.location.href = _loginMethodSmsOtpUrl;
    };

    const redirectToHomePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            redirectToHome();
        }  
    }
    
    const handleEscape = (event) => {       
        if (event.keyCode === 27){
            props.close();
        }
    };

   
    return(
        <Fragment >           
            <div id='popupContainer' 
                     tabIndex={0} 
                     className={classes.popup_box} 
                     role="dialog" 
                     aria-labelledby="popupTitle" 
                     aria-describedby="popupDesc"
                     onKeyDown={handleEscape}
            >
                <div className={classes.content}>                    
                    <div className={classes.popup_title} id='popupTitle' >
                        {Translate('N_General_Existing_Account')}                       
                    </div>
                    <div className={classes.popup_desc} id='popupDesc' >
                        {Translate('N_Login_Exist_Acc_Reg_Or_Reset')}                        
                    </div>
                                                      
                    <div className={classes.button_container}>
                        <button 
                            className={classes.button_cancel} 
                            id='fwdToResetPassword' 
                            onClick={redirectToForgottenPassword}
                            onKeyPress={forgotPapssPress}
                        >                            
                            <span>{Translate('N_General_To_Reset_Password')}</span>                            
                        </button>
                        <button 
                            className={classes.button} 
                            id='returnToHomePage'
                            onClick={redirectToHome}    
                            onKeyPress={redirectToHomePress} 
                        >                            
                            <span>{Translate('N_Login_application_link_to_entrance')}</span>                     
                        </button>                        
                    </div>                    
                </div>               
            </div>
        </Fragment>      
     );

};
export default PreRegTwoContact;